const ADDRESS_PAGE = 'addressPage';
const DETAILS = 'details';
const ENERGY_DETAILS = 'energyDetails';
const INCOME_PROTECTOR = 'incomeProtector';
const PARTNER = 'partner';
const SAVE_FOR_LATER = 'saveForLater';
const BROADBAND = 'broadband';
const BOILER_HOME_COVER = 'boilerHomeCover';
const ENERGY_TARIFF = 'energyTariff';
const CBC_CALC = 'cbcCalc';

// In-Life forms
const IN_LIFE_ENERGY_TARIFF = 'inLifeEnergyTariff';

export {
  ADDRESS_PAGE,
  DETAILS,
  ENERGY_DETAILS,
  INCOME_PROTECTOR,
  PARTNER,
  SAVE_FOR_LATER,
  BROADBAND,
  BOILER_HOME_COVER,
  ENERGY_TARIFF,
  CBC_CALC,
  IN_LIFE_ENERGY_TARIFF,
};
